// src/api/api.js
import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 1. Intercepteur de REQUÊTE (Ton code existant)
// Ajoute le token JWT à chaque requête sortante
api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

// Surveille les réponses qui reviennent du serveur
api.interceptors.response.use(
    // Si la réponse est un succès (200, 201...), on la laisse passer
    response => {
        return response;
    },
    // Si la réponse est une erreur
    error => {
        // On vérifie si l'erreur vient d'une réponse serveur et si c'est une 401 (Non autorisé / Token expiré)
        if (error.response && error.response.status === 401) {
            console.warn("Session expirée détectée par Axios. Déconnexion...");

            // A. On nettoie le localStorage (token et infos user)
            localStorage.removeItem('token');
            localStorage.removeItem('user'); // Si tu stockes l'user ici
            // Ajoute ici d'autres clés à nettoyer si nécessaire (ex: localStorage.removeItem('matchingTask'))

            // B. On évite de boucler si on est déjà sur le login
            if (window.location.pathname !== '/login') {
                // C. Force le rechargement complet et la redirection
                // window.location.href est mieux que navigate() ici car il vide la mémoire de React (les states)
                window.location.href = '/login';
            }
        }

        // On rejette l'erreur pour que tes composants puissent quand même arrêter leurs loaders (setLoading(false))
        return Promise.reject(error);
    }
);

export default api;